module.exports = __webpack_public_path__ + "img/bgImg_m.126c6b0a.jpg";